import { TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL } from 'Tracking/events/events.trackings';
import { BE_GA_DEFAULT_PAYLOAD } from 'Views/booking/constants';

export const TRACK_BE_EVENT_GA_ACTIVITIES = {
  ...BE_GA_DEFAULT_PAYLOAD,
  actionGA: 'activities',
};
export const TRACK_BE_EVENT_GA_CHILDCARE = {
  ...BE_GA_DEFAULT_PAYLOAD,
  actionGA: 'childcare',
};

export const TRACK_CLICK_EVENT_BE_RENTALS = {
  ...BE_GA_DEFAULT_PAYLOAD,
  ...TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL,
};
